import { render, staticRenderFns } from "./OrientationCard.vue?vue&type=template&id=613b69e1&scoped=true"
import script from "./OrientationCard.vue?vue&type=script&lang=ts"
export * from "./OrientationCard.vue?vue&type=script&lang=ts"
import style0 from "./OrientationCard.vue?vue&type=style&index=0&id=613b69e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b69e1",
  null
  
)

export default component.exports